import React from 'react'
import EditCategoryComponent from './EditCategoryComponent'

const EditCategory = () => {
    return (
        <EditCategoryComponent />
    )
}

export default EditCategory